const AppConfig = {
    BASE_SERVER:process.env.REACT_APP_BASE_SERVER,
    GET_CUSTOM_TOKEN:process.env.REACT_APP_GET_CUSTOM_TOKEN,
    DEFAULT_CONFIG:process.env.REACT_APP_DEFAULT_CONFIG,
}
export default  AppConfig